import React, { useState, useRef, useEffect } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { FiCamera, FiUser } from 'react-icons/fi';

const ParticipantPhotoUpload = ({ onFileSelect, initialPreviewUrl = null, loading = false }) => {
    const [preview, setPreview] = useState(initialPreviewUrl);
    const [imageLoading, setImageLoading] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (initialPreviewUrl) {
            setPreview(initialPreviewUrl);
            setImageLoading(true);
        }
    }, [initialPreviewUrl]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validation
        const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
        if (!validTypes.includes(file.type)) {
            alert('Por favor, selecione uma imagem válida (JPEG, PNG ou GIF).');
            return;
        }

        if (file.size > 5 * 1024 * 1024) { // 5MB
            alert('A imagem deve ter no máximo 5MB.');
            return;
        }

        // Preview
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreview(reader.result);
        };
        reader.readAsDataURL(file);

        // Callback
        if (onFileSelect) {
            onFileSelect(file);
        }
    };

    const handleClick = () => {
        if (!loading) {
            fileInputRef.current.click();
        }
    };

    const containerStyle = {
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: '#f8f9fa', // bg-light
        border: `2px dashed ${isHovered ? '#0d6efd' : '#dee2e6'}`, // primary or gray-300
        cursor: loading ? 'wait' : 'pointer',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: isHovered ? '0 0 0 4px rgba(13, 110, 253, 0.25)' : 'none'
    };

    const iconStyle = {
        fontSize: '2rem',
        color: '#6c757d', // text-muted
        zIndex: 2
    };

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: isHovered ? 1 : 0,
        transition: 'opacity 0.2s ease',
        zIndex: 3
    };

    return (
        <div className="d-flex flex-column align-items-center mb-4">
            <div 
                style={containerStyle}
                onClick={handleClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                title="Clique para alterar a foto"
            >
                {loading ? (
                    <Spinner animation="border" variant="primary" />
                ) : (
                    <>
                        {preview ? (
                            <>
                                {imageLoading && (
                                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', zIndex: 1 }}>
                                        <Spinner animation="border" variant="primary" size="sm" />
                                    </div>
                                )}
                                <img 
                                    src={preview} 
                                    alt="Preview" 
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: imageLoading ? 'none' : 'block' }} 
                                    onLoad={() => setImageLoading(false)}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        setPreview(null);
                                        setImageLoading(false);
                                    }}
                                />
                            </>
                        ) : (
                            <FiUser style={iconStyle} />
                        )}
                        
                        <div style={overlayStyle}>
                            <FiCamera style={{ color: 'white', fontSize: '1.5rem' }} />
                        </div>
                    </>
                )}
                
                <input 
                    type="file" 
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept="image/jpeg,image/png,image/gif"
                    style={{ display: 'none' }} 
                />
            </div>
            <p className="text-muted small mb-0">
                {preview ? 'Trocar Foto' : 'Adicionar Foto'}
            </p>
        </div>
    );
};

export default ParticipantPhotoUpload;
